export const longOsmType = {
  W: 'way',
  N: 'node',
  R: 'relation',
  w: 'way',
  n: 'node',
  r: 'relation',
  // Just so we can use this for both format
  way: 'way',
  node: 'node',
  relation: 'relation',
}
export const shortOsmType = {
  way: 'w',
  node: 'n',
  relation: 'r',
  // Just so we can use this for both format
  w: 'w',
  n: 'n',
  r: 'r',
  W: 'w',
  N: 'n',
  R: 'r',
}
